/**
 * How many days a birth month can have [ISS-148].
 *
 * **No year is collected** — decision 0032 asks for day and month only, and the Bullhorn field the lookup
 * matches on is `customText23`, *Birthday (MM/DD)* [03-us-kid-2]. With no year there is no leap year to rule
 * out, so February offers **29**: a real person born on 29 February has to be able to say so.
 *
 * The list the candidate picks from used to be 1–31 whatever the month, so `31/02` was a choice the form
 * accepted and a birthday nobody has.
 */
const DAYS_IN_MONTH: readonly number[] = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

/** The most any month allows — what the list offers before a month is chosen. */
export const MAX_BIRTH_DAY = 31;

/**
 * The days `month` (`'1'`–`'12'`, as the month dropdown sends it) can have. No month, or one this form cannot
 * produce, answers {@link MAX_BIRTH_DAY}: the list only narrows once a month says it should.
 */
export function daysInBirthMonth(month: string): number {
  return DAYS_IN_MONTH[Number(month) - 1] ?? MAX_BIRTH_DAY;
}

/** Whether `day` exists in `month`. An unchosen day or month is not a contradiction, only unfinished. */
export function isDayInBirthMonth(day: string, month: string): boolean {
  if (day === '' || month === '') return true;
  return Number(day) <= daysInBirthMonth(month);
}
